import "../styles/ATBCard.css";

export default function ATBCard({ title, logo, link, children }) {
  return (
    <div className="atb-card">
      <div className="atb-card-header">
        <a
          href={link}
          target="_blank"
          rel="noopener noreferrer"
          className="atb-card-link"
        >
          <img src={logo} alt={`${title} logo`} className="atb-card-logo" />
        </a>
        <h2 className="atb-card-title">{title}</h2>
      </div>
      <div className="atb-card-content">{children}</div>
    </div>
  );
}
